/**
 * Right rail — dedicated to the always-visible mobile preview.
 *
 * The activity ticker moved to LeftRail.ts (under Anomalies) so the
 * right rail can host the iPhone 17 Pro at 1:1 real-size without a
 * second panel competing for vertical space.
 */
import { html, type TemplateResult } from "lit-html";

const PROD_USER_APP = "https://thekitchen.cloud";

// iPhone 17 Pro logical dimensions — most users target this device.
// Width 402 + 16px device chrome (8 each side) = 418, fits in the
// 420px right rail with 2px margin. Rendered at 1:1 (real size, no
// scale) so what you see is what users see.
const PREVIEW_WIDTH  = 402;
const PREVIEW_HEIGHT = 874;

export function renderRightRail(): TemplateResult {
  return html`
    <aside class="right-rail">
      ${mobilePreviewPanel()}
    </aside>
  `;
}

function mobilePreviewPanel(): TemplateResult {
  return html`
    <section class="panel" style="padding:0;overflow:hidden;">
      <div class="panel__title" style="padding:14px 16px 6px;margin-bottom:0;">
        <span>Mobile preview · iPhone 17 Pro</span>
        <span class="panel__title-actions">
          ${PROD_USER_APP.replace(/^https?:\/\//, "")} · 1:1
        </span>
      </div>
      <div style="position:relative;background:#000;padding:8px;
                   display:flex;justify-content:center;">
        <div style="
          width:${PREVIEW_WIDTH}px;
          height:${PREVIEW_HEIGHT}px;
          border-radius:48px;
          overflow:hidden;
          background:#000;
          box-shadow: 0 0 0 8px #1a1a1c, 0 24px 48px -8px rgba(0,0,0,0.8);
          position:relative;
        ">
          <div style="position:absolute;top:11px;left:50%;
                        transform:translateX(-50%);
                        width:120px;height:36px;background:#000;
                        border-radius:18px;z-index:2;pointer-events:none;"></div>
          <iframe
            src="${PROD_USER_APP}"
            style="width:${PREVIEW_WIDTH}px;height:${PREVIEW_HEIGHT}px;
                    border:none;display:block;background:#000;"
            sandbox="allow-scripts allow-same-origin allow-popups"
            loading="lazy"
            title="thekitchen.cloud (production user app)"
          ></iframe>
        </div>
      </div>
      <div style="padding:8px 16px 14px;font-size:11px;
                   color:var(--text-quaternary);
                   border-top:1px solid var(--border-1);">
        Real-size 402×874 · for compare / branch preview /
        file drop, open the <strong style="color:var(--accent-purple-light);">
        Mobile preview</strong> tab.
      </div>
    </section>
  `;
}
